// Converte data no formato "dd/mm/yyyy HH:mm:ss" para um objeto Date
export function parseDateBR(str) {
    const [datePart, timePart] = str.split(' ');
    const [day, month, year] = datePart.split('/');
    return new Date(`${year}-${month}-${day}T${timePart}`);
  }
  
  // Lista dos meses em português
  export function getMonthBr() {
    return [
      'janeiro',
      'fevereiro',
      'março',
      'abril',
      'maio',
      'junho',
      'julho',
      'agosto',
      'setembro',
      'outubro',
      'novembro',
      'dezembro'
    ];
  }
  
  // Formata a data como "06 de junho de 2025 09:00"
  export function formatDayAndTime(_date) {
    try {
      const date = parseDateBR(_date);
  
      const dia = String(date.getDate()).padStart(2, '0');
      const mesNome = getMonthBr()[date.getMonth()];
      const ano = date.getFullYear();
  
      const horas = String(date.getHours()).padStart(2, '0');
      const minutos = String(date.getMinutes()).padStart(2, '0');
  
      return `${dia} de ${mesNome} de ${ano} ${horas}:${minutos}`;
    } catch (e) {
      console.error('Erro ao formatar data:', e);
      return _date; // retorna a string original se algo falhar
    }
  }
  